import React, { useEffect, useState } from 'react'
import './index.scss'
import { connect } from 'react-redux'
import ReusableButton from '../reusableComponents/button/customButton'
import LandTrustMap from '../map/landTrust'
import { landTrustDetailsMenuBarexpand } from '../../../action/land-trust-menu-bar'
import { landTrustDetailsMenuBarHide } from '../../../action/land-trust-menu-bar'
import { fetchPrivateLandGetFilterValues } from '../../../action/private-lands-action'

import Topmenu from './topmenu'
const LandTrustMainScreen = (props) => {
    let [loading, setLoading] = useState(true)

    useEffect(() => {
        setTimeout(() => {
            props.huntMapLoader && props.stopMapLoading()
        }, [1000 * 0.75])

        props.fetchPrivateLandGetFilterValues()
        props.landTrustDetailsMenuBarHide()
    }, [])




    return (
        <div className='hunt-planner-container'>
            <Topmenu />

            {/* {props.huntPlannerUnitRightMenuBar.expanded && <RightMenubar></RightMenubar>} */}

            <div className='hunt-planner-map-container'>
                <LandTrustMap
                    // width="calc(-23.4375vw - 78px + 100vw)" 
                    width="calc(100vw - 78px)"
                    height="calc(-130px + 100vh)"
                    top="68px"
                    left="0px">
                </LandTrustMap>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    // mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null, pavan
    huntplannerMorefiltersExpand: state.huntplannerMorefiltersExpand,
    huntMapLoader: state.huntMapLoader,
    huntPlannerUnitRightMenuBar: state.huntPlannerUnitRightMenuBar,
    huntplannerRightToolbar: state.huntplannerRightToolbar,
})

const mapDispatchToProps = dispatch => ({
    // fetchHuntPlannerLayers: (cb) => dispatch(fetchHuntPlannerLayers(cb)),
    // stopMapLoading: () => dispatch(stopMapLoading()),
    landTrustDetailsMenuBarHide: () => dispatch(landTrustDetailsMenuBarHide()),
    // huntPlannerRightMenuBarClose: () => dispatch(huntPlannerRightMenuBarClose()),
    fetchPrivateLandGetFilterValues: () => dispatch(fetchPrivateLandGetFilterValues())
})

export default connect(mapStateToProps, mapDispatchToProps)(LandTrustMainScreen)